import { render } from "./Reset.vue?vue&type=template&id=00f03c58&scoped=true&ts=true"
import script from "./Reset.vue?vue&type=script&lang=ts"
export * from "./Reset.vue?vue&type=script&lang=ts"

import "./Reset.vue?vue&type=style&index=0&id=00f03c58&scoped=true&lang=css"
import "./Reset.vue?vue&type=style&index=1&id=00f03c58&lang=scss"

import exportComponent from "C:\\開発\\PSAP\\おくやみシステム\\OJ0000P_Vue\\OJ0000P\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f03c58"]])

export default __exports__